import { observable, computed, action, IObservableArray } from "mobx";

import { AppStore, AreaStore } from "./AppStore";
import * as PortalManagement from "../PortalManagement";
import { DialogStore } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";
import { AreaUiInfoImpl } from "../States/AreaUiInfo";
import * as UiStore from "../States/AreaUiInfo";
import { UiRepos } from "./UiStore";


export class PortalStore extends AreaStore {

	@observable searchTerm: string = "";
	model: IObservableArray<PortalManagement.PortalInfo> = observable.array([]);
	searchTimeoutHandle: number;
	areaUiInfo: UiStore.AreaUiInfoImpl = new UiStore.AreaUiInfoImpl(UiRepos.PORTAL_UI_INFO);

	search() {
		// loadAll
		this.isBusy = true;
		PortalManagement.getPortalInfosAsync().then(portals => {
			this.model.replace(portals);
			this.isBusy = false;
		}).catch(error => {
			DialogStore.showError(Strings.general.errorDialogTitle, error);
			this.isBusy = false;
		});
	}

	loadUiSettings() {
		this.areaUiInfo.asideWidth = UiRepos.portalUiInfo.asideWidth;
		this.areaUiInfo.isCollapsed = UiRepos.portalUiInfo.isCollapsed;
		this.areaUiInfo.contentGroupAccordionStatus.replace(UiRepos.portalUiInfo.contentGroupAccordionStatus);
	}
}